/* eslint-disable global-require */
let FLAGS = {};

const importFlags = async () => {
  // eslint-disable-next-line no-undef
  if (ENV === 'production') {
    const flagModule = await import('./production');
    FLAGS = flagModule.default;
  } else {
    const flagModule = await import('./development');
    FLAGS = flagModule.default;
  }

}

export const enabled = (flag) => {
  return FLAGS[flag];
};
